/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementGenerateZipCertResponse } from './EventManagementGenerateZipCertResponse';

export type EventManagementGenerateZipCertResponseApiRespoonse = {
    data?: EventManagementGenerateZipCertResponse;
    status?: EventManagementGenerateZipCertResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementGenerateZipCertResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

